export const COOKIE_DOMAIN = '.connectrn.com'
